import { type SortOption } from "@tablescape/state";

export enum COLLECTION_FILTER_IDS {
  COLOR = "filter.v.t.shopify.color-pattern",
  MATERIAL = "filter.p.m.category.material",
  PRICE = "filter.v.price",
  SIZE = "filter.p.m.category.size",
}

export enum COLLECTION_FILTER_SORT_PARAMS {
  COLOR = "color",
  MATERIAL = "material",
  PRICE = "price",
  SIZE = "size",
  SORT = "sort",
}

export const DEFAULT_COLLECTION_SORT_OPTIONS: SortOption[] = [
  {
    value: { sortKey: "COLLECTION_DEFAULT", reverse: false },
    name: "Featured",
  },
  {
    value: { sortKey: "CREATED", reverse: true },
    name: "Newest",
  },
  {
    value: { sortKey: "PRICE", reverse: false },
    name: "Price: Low-High",
  },
  {
    value: { sortKey: "PRICE", reverse: true },
    name: "Price: High-Low",
  },
  {
    value: { sortKey: "BEST_SELLING", reverse: false },
    name: "Bestsellers",
  },
];

export const COLLECTION_FILTER_INITIAL_LIST_SIZES: {
  [key in COLLECTION_FILTER_IDS]?: number;
} = {
  [COLLECTION_FILTER_IDS.COLOR]: 12,
  [COLLECTION_FILTER_IDS.MATERIAL]: 4,
};
